const E = {
  0: `Target your search by selecting from Jobs & Samples, eCOCs Templates, Orders or Invoices.
      The available search fields will change accordingly.`,
  1: `By default, anything you put in the search boxes will be treated as a wildcard search.
      \n Select Exact Match if you know the exact text to search for.`,
  2: 'If you want to start a completely new search, select clear to remove all criteria.',
  3: 'Once you have entered all your criteria, select search to start the search.',
  4: 'Selection of Clear Search will remove the search criteria filters applied, displaying the main page.',
  5: 'Your Jobs & Samples search will list results in two tabs; Jobs which lists all Jobs found and Samples which lists all Samples of all Jobs found.',
};

const F = {
  0: `Ciblez votre recherche en sélectionnant dans Dossier et échantillons, Modèles eCDR, Commandes ou Factures.
      Les champs de recherche disponibles changeront en conséquence.`,
  1: `Par défaut, tout ce que vous mettez dans les champs de recherche sera traité comme une recherche générique.
      Sélectionnez Correspondance exacte si vous connaissez le texte exact à rechercher.`,
  2: 'Si vous souhaitez lancer une nouvelle recherche, sélectionnez Effacer pour supprimer tous les critères.',
  3: 'Une fois que vous avez entré tous vos critères, sélectionnez Recherche pour lancer la recherche.',
  4: 'La sélection de Clear Search supprimera les filtres de critères de recherche appliqués, affichant la page principale.',
  5: 'Votre recherche Jobs & Samples listera les résultats dans deux onglets; Jobs qui répertorie tous les Jobs trouvés et échantillons qui répertorie tous les échantillons de tous les Jobs trouvés.',
};

export default{ E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/tutorials/search.js